<template>
  <div
    :class="{ 'preview-playbar' : toggle }"
    class="player-bar">
    <div class="control">
      <img
        class="play-button"
        :src="`/img/vector/${ buttonImage }`"
        @click.prevent="togglePlay" />
    </div>
    <div
      class="start-btn">
      <a
        href="#"
        @click.prevent="onStartFromBegin">
        <img src="/img/vector/icon-back.svg">
      </a>
    </div>
    <div
      class="five-rewind">
      <a
        href="#"
        @click.prevent="onRewind5s">
        <img src="/img/vector/icon-five-back.svg">
      </a>
    </div>
    <div
      class="five-back">
      <a
        href="#"
        @click.prevent="onForward5s">
        <img src="/img/vector/icon-five-front.svg">
      </a>
    </div>
    <div
      v-if="!hideReset"
      :class="{ 'btn-off': toggle }"
      class="five-back ">
      <a
        href="#"
        :class="{'btn-off': playing}"
        @click.prevent="onReset">
        <img src="/img/vector/icon-reset.svg">
      </a>
    </div>
    <div class="time">
      {{ currentTimeString }} / {{ msToTime(durationString) }}
    </div>
    <div class="seekbar">
      <vue-slider
        v-model="sliderValue"
        :process-style="{ 'background-color': '#fff' }"
        tooltip="none"
        @drag-start="onDragStart"
        @drag-end="onDragEnd"
        @change="onChange" />
    </div>
    <div class="preview">
      <div
        v-if="!lockPreview"
        class="on-off">
        <span>プレビュー</span>
        <label class="switch">
          <input
            v-model="toggle"
            type="checkbox"
            @click="onPreviewClicked">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="time-forward-back">
        <span>再生速度</span>
        <div class="play-speed">
          <button
            type="button"
            class="play-speed-button"
            @click.prevent="onRateClicked">
            {{ speedRatelabel === '' ? '通常' : speedRatelabel }}
          </button>
          <div
            v-show="showRateSelect"
            class="play-speed-list">
            <div
              class="play-speed-item"
              rate="0.25"
              @click.prevent="onSelectedRate">
              ×0.25
            </div>
            <div
              class="play-speed-item"
              rate="0.50"
              @click.prevent="onSelectedRate">
              ×0.50
            </div>
            <div
              class="play-speed-item"
              rate="0.75"
              @click.prevent="onSelectedRate">
              ×0.75
            </div>
            <div
              class="play-speed-item"
              rate="1.00"
              @click.prevent="onSelectedRate">
              通常
            </div>
            <div
              class="play-speed-item"
              rate="1.25"
              @click.prevent="onSelectedRate">
              ×1.25
            </div>
            <div
              class="play-speed-item"
              rate="1.50"
              @click.prevent="onSelectedRate">
              ×1.50
            </div>
            <div
              class="play-speed-item"
              rate="2.00"
              @click.prevent="onSelectedRate">
              ×2.00
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { getPreSignedUrl } from '../../logic/url'

export default {
  name: 'SyncAudioPlayer',

  components: {
    VueSlider,
  },
  props: {
    url: {
      type: String,
      required: false,
      default: '',
    },
    durationString: {
      type: Number,
      required: false,
      default: 0,
    },
    currentPlayUrl: {
      type: String,
      required: false,
      default: '',
    },
    // trueの場合、プレビュー切替UIを隠し常にプレビューON(歌詞ハイライト有効)の状態に固定する
    lockPreview: {
      type: Boolean,
      default: false,
    },
    // trueの場合、RESETボタン(頭出しボタンと同じ「先頭に戻す」動作)を隠す
    hideReset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentTime: 0,
      sliderValue: 0,
      playingSpeedRate: 1,
      showRateSelect: false,
      speedRatelabel: '',
      playing: false,
      loading: false,
      audio: null,
      playTimer: null,
      toggle: this.lockPreview,

      isDragging: false,
    }
  },
  computed: {
    currentTimeString() {
      const currentTimeMs = Math.round(this.currentTime * 1000)
      return this.msToTime(currentTimeMs)
    },
    buttonImage() {
      if (this.loading) return 'spinner.gif'
      if (this.playing) return 'icon-pause.svg'
      return 'icon-play.svg'
    },
  },
  watch: {
    url() {
      if (this.url && this.audio) {
        this.stopPlayback()
      }
    },
    currentPlayUrl() {
      if (this.audio && this.url !== this.currentPlayUrl) {
        this.stopPlayback()
      }
    },
    playingSpeedRate() {
      if (this.audio) {
        this.audio.playbackRate = this.playingSpeedRate
      }
    },
  },
  destroyed() {
    this.clearTimer()
    if (this.audio) {
      this.audio.pause()
      this.audio.src = ''
      this.audio = null
    }
  },
  mounted() {
  },
  methods: {
    updateTimer() {
      if (!this.audio || this.isDragging) return

      this.currentTime = this.audio.currentTime
      const durSec = this.durationString / 1000

      if (durSec > 0) {
        this.sliderValue = (this.currentTime / durSec) * 100
      }

      if (this.toggle) {
        this.$emit('timeupdate', this.currentTime)
      }
    },

    clearTimer() {
      if (this.playTimer) {
        clearInterval(this.playTimer)
        this.playTimer = null
      }
    },

    stopPlayback() {
      if (this.audio) {
        this.audio.pause()
      }
      this.playing = false
      this.clearTimer()
    },

    async setUpAudioPlayer() {
      if (this.audio) return

      this.loading = true
      this.audio = new Audio()

      this.audio.addEventListener('ended', () => {
        this.playing = false
        this.currentTime = 0
        this.sliderValue = 0
        this.clearTimer()
      })

      this.audio.addEventListener('waiting', () => {
        this.loading = true
      })

      this.audio.addEventListener('playing', () => {
        this.loading = false
      })

      this.audio.addEventListener('canplay', () => {
        this.loading = false
      })

      const audioUrl = await getPreSignedUrl(this.url)
      this.audio.src = audioUrl
      this.audio.load()

      await new Promise((resolve) => {
        if (this.audio.readyState >= 1) {
          resolve()
        } else {
          this.audio.addEventListener('loadedmetadata', () => resolve(), { once: true })
          this.audio.addEventListener('error', () => resolve(), { once: true })
        }
      })
    },

    async togglePlay() {
      if (!this.audio) {
        await this.setUpAudioPlayer()
      }

      if (this.playing) {
        this.audio.pause()
        this.playing = false
        this.clearTimer()
      } else {
        this.audio.playbackRate = this.playingSpeedRate

        try {
          await this.audio.play()
          this.playing = true
          this.clearTimer()
          this.playTimer = setInterval(this.updateTimer, 50)

          this.$emit('play-start', this.url, this.audio, this.currentTime)
        } catch (e) {
          this.loading = false
          this.clearTimer()
        }
      }
    },

    applySeek(targetTime) {
      const durSec = this.durationString / 1000
      let time = targetTime
      if (time < 0) time = 0
      if (time > durSec) time = durSec

      this.currentTime = time
      if (durSec > 0) {
        this.sliderValue = (time / durSec) * 100
      }

      if (this.audio) {
        this.audio.currentTime = time
      }

      if (this.toggle) {
        this.$emit('timeupdate', this.currentTime)
      }
    },

    onStartFromBegin() {
      this.applySeek(0)
    },

    onForward5s() {
      this.applySeek(this.currentTime + 5)
    },

    onRewind5s() {
      this.applySeek(this.currentTime - 5)
    },

    onDragStart() {
      this.isDragging = true
    },

    onChange(val) {
      const durSec = this.durationString / 1000
      const targetTime = durSec * (val / 100)

      if (Math.abs(targetTime - this.currentTime) < 0.2) {
        return
      }

      if (this.isDragging) {
        this.currentTime = targetTime
        this.sliderValue = val
      } else {
        this.applySeek(targetTime)
      }
    },

    onDragEnd() {
      this.isDragging = false
      const durSec = this.durationString / 1000
      this.applySeek(durSec * (this.sliderValue / 100))
    },

    onPreviewClicked() {
      this.$emit('previewMode', !this.toggle)
    },
    onReset() {
      this.$emit('reset')
    },
    onRateClicked() {
      this.showRateSelect = true
    },
    onSelectedRate(event) {
      this.showRateSelect = false
      this.speedRatelabel = event.currentTarget.innerText
      this.playingSpeedRate = Number(event.target.getAttribute('rate'))
      if (this.audio) {
        this.audio.playbackRate = this.playingSpeedRate
      }
    },
    msToTime(duration) {
      const hour = Math.floor(duration / 3600000)
      const minute = Math.floor((duration - 3600000 * hour) / 60000)
      const mm = (`00${minute}`).slice(-2)
      const ms = (`00000${duration % 60000}`).slice(-5)
      const time = `${mm}:${ms.slice(0, 2)}.${ms.slice(2, 5)}`
      return time
    },
  },
}
</script>
<style scoped>
.player-bar {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.control {
}
.seekbar {
  flex-grow: 1;
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 3px;
}
.time {
  font-family: monospace, monospace;
  margin-right: 8px;
  color: #fff;
  font-size: 14px;
  margin-top: 5px
}
.play-button {
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin: 5px;
}
.play-speed {
    position: relative;
}

.play-speed-list {
  background: #fff;
  color: #444;
  position: absolute;
  top: 27px;
  left: -19px;
  width: 90px;
  box-shadow: 0 0 5px #b1b1b1;

}
.play-speed-item:hover {
  background: #e9e7e7;
  cursor: pointer;
}

.play-speed-item {
  padding: 9px 0 5px 0;
}

button.play-speed-button {
  position: relative;
  width: 54px;
  color: #444;
}

button.play-speed-button:focus {
  background: #fff;
}

.vue-slider-dot-handle {
  background-color: #f8a104 !important;
}
.preview .time-forward-back {
  align-self: end;
  display: flex;
  gap: 10px;
}
.preview .time-forward-back span {
  font-size: 14px;
  line-height: 26px;
}

.player-bar .preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.player-bar.preview-playbar {
  background: #282c34;
  opacity: 0.9;
}
</style>
